













































































import BaseComponent from "@/asdcom/BaseComponent";
import { Asdcom } from "../../../asdcom/appservice.asdcom";
import {Component, Vue, Prop, Inject} from 'vue-property-decorator';
import { SendPasswordResetCodeByUserNameInput } from '../../../asdcom/apiproxy/apiproxy.dto';

@Component({})
export default class ForgetPassword extends BaseComponent {
  forgotPassModel = new SendPasswordResetCodeByUserNameInput();
  accountService = new Asdcom.AccountAppService();
  loading: boolean = false;

  public back(): void {
    this.$router.push({name: "login"});
    // this.forgotPassModel.userName = "";
  }

  resetPassword() {
    this.ValidateAll().then(async (isValid: boolean) => {
      if (isValid) {
        const msg = document.createElement("p");
        msg.innerHTML = this.L("SendPasswordResetLink_Message") + `<br/><br/>` + this.L("AgreeToReceiveResetPasswordEmail");
        sweetAlert({
          title: this.L("ResetPassword"),
          content: {element: msg},
          icon:"info",
          buttons: ["Cancel", "Continue"]
          // dangerMode: false 
        }).then((value) => {
          if (value) {
            this.back();
            // this.$store.dispatch({
            //     type: 'asdcom/sendPasswordResetCodeDispatch',
            //     data: this.forgotPassModel
            // });
            this.$appsvs.account.sendPasswordResetCodeByUserName(this.forgotPassModel)
          } else {
            this.back();
          }
        })
      }
    })
  }
}
